import { render, staticRenderFns } from "./ObiColorPicker.vue?vue&type=template&id=36a3e4c5&scoped=true&"
import script from "./ObiColorPicker.vue?vue&type=script&lang=js&"
export * from "./ObiColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ObiColorPicker.vue?vue&type=style&index=0&id=36a3e4c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a3e4c5",
  null
  
)

export default component.exports